/** The outline colour of the robot, shared with the logo and the course map. */
const INK = '#1B2A4A';

export type KataRobotProps = {
    size?: number;
};

/** The whole KataQuiz robot, the guide of the course page; the logo uses its head alone. Decorative, so hidden from screen readers. */
export function KataRobot({ size = 44 }: KataRobotProps) {
    return (
        <svg width={ size } height={ size * 52 / 44 } viewBox="0 0 44 52" aria-hidden="true" style={ { flexShrink: 0 } }>
            <line x1="22" y1="4" x2="22" y2="10" stroke={ INK } strokeWidth="2"/>
            <circle cx="22" cy="4" r="3.5" fill="#FF6B4A" stroke={ INK } strokeWidth="1.5"/>
            <rect x="8" y="10" width="28" height="22" rx="6" fill="#3D7BEA" stroke={ INK } strokeWidth="2"/>
            <circle cx="17" cy="20" r="4" fill="#FFFFFF" stroke={ INK } strokeWidth="1.5"/>
            <circle cx="27" cy="20" r="4" fill="#FFFFFF" stroke={ INK } strokeWidth="1.5"/>
            <circle cx="18" cy="20" r="1.8" fill={ INK }/>
            <circle cx="28" cy="20" r="1.8" fill={ INK }/>
            <path d="M17 27 q5 3 10 0" stroke={ INK } strokeWidth="1.6" fill="none" strokeLinecap="round"/>
            <rect x="11" y="34" width="22" height="16" rx="4" fill="#3D7BEA" stroke={ INK } strokeWidth="2"/>
            <circle cx="22" cy="42" r="3" fill="#FFC940" stroke={ INK } strokeWidth="1.4"/>
        </svg>
    );
}
